export default {
  title: 'Payment invoice',
  details: 'Invoice details',
  detailsInfo: 'If the details are incorrect, you can update them in your account settings.',
  createButton: {
    init: 'Create invoice',
    loading: 'Creating invoice'
  },
  invoiceLink: 'Open invoice'
}